/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { Customer } from '@/auth/types';
import { fetchGraphQl } from '../fetch-graphql';
import { CREATE_CUSTOMER } from './graphql/createCustomer.graphql';
import { CREATE_CUSTOMER_V2 } from './graphql/createCustomerV2.graphql';
import { handleNetworkError } from '@/auth/lib/network-error';
import { setReCaptchaToken } from '@/auth/lib/setReCaptchaToken';
import { transformCreateCustomer } from '@/auth/data/transforms';
import { CustomerModel } from '@/auth/data/models';
import { transformDobForm } from '@/auth/lib/transformDobForm';

export const createCustomer = async (
  forms: Customer,
  apiVersion2: boolean
): Promise<CustomerModel> => {
  await setReCaptchaToken();

  const response = await fetchGraphQl(
    apiVersion2 ? CREATE_CUSTOMER_V2 : CREATE_CUSTOMER,
    {
      method: 'POST',
      variables: {
        input: {
          ...transformDobForm(forms),
        },
      },
    }
  ).catch(handleNetworkError);

  return transformCreateCustomer(response, apiVersion2);
};
